export default "__VITE_ASSET__BR27znOS__"